var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainPetCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_3361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81186 6.03728C6.09573 6.85363 6.09788 7.66089 5.8947 8.29882C5.69157 8.93658 5.29749 9.37468 4.79901 9.54801C4.30053 9.72135 3.71966 9.62226 3.16466 9.24811C2.60953 8.87387 2.11037 8.23942 1.82651 7.42307C1.54264 6.60672 1.54049 5.79945 1.74367 5.16153C1.9468 4.52376 2.34088 4.08566 2.83936 3.91233C3.33784 3.739 3.91872 3.83809 4.47371 4.21224C5.02885 4.58648 5.528 5.22092 5.81186 6.03728Z",
    fill: "#C8874D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06293 6.57535C5.21982 7.02655 5.22069 7.47187 5.10894 7.82273C4.99722 8.17349 4.78152 8.41159 4.51136 8.50553C4.2412 8.59947 3.92431 8.54656 3.61907 8.34079C3.31375 8.13495 3.03813 7.78517 2.88124 7.33397C2.72435 6.88277 2.72349 6.43745 2.83524 6.08659C2.94696 5.73583 3.16266 5.49773 3.43282 5.40379C3.70298 5.30985 4.01987 5.36275 4.32511 5.56853C4.63043 5.77436 4.90604 6.12415 5.06293 6.57535Z",
    fill: "#B26B3F",
    stroke: "#A86027",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3719 4.43878C10.3719 5.30361 10.1098 6.06711 9.71022 6.60295C9.31064 7.13874 8.79758 7.42211 8.27409 7.42211C7.7506 7.42211 7.23755 7.13874 6.83796 6.60295C6.43834 6.06711 6.17627 5.30361 6.17627 4.43878C6.17627 3.57395 6.43834 2.81045 6.83796 2.27461C7.23755 1.73882 7.7506 1.45544 8.27409 1.45544C8.79758 1.45544 9.31064 1.73882 9.71022 2.27461C10.1098 2.81045 10.3719 3.57395 10.3719 4.43878Z",
    fill: "#C8874D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30583 4.43874C9.30583 4.87359 9.17399 5.25561 8.97529 5.52204C8.77661 5.78844 8.52552 5.9244 8.2741 5.9244C8.02269 5.9244 7.7716 5.78844 7.57292 5.52204C7.37422 5.25561 7.24238 4.87359 7.24238 4.43874C7.24238 4.00388 7.37422 3.62186 7.57292 3.35544C7.7716 3.08904 8.02269 2.95308 8.2741 2.95308C8.52552 2.95308 8.77661 3.08904 8.97529 3.35544C9.17399 3.62186 9.30583 4.00388 9.30583 4.43874Z",
    fill: "#B26B3F",
    stroke: "#A86027",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3987 4.79266C15.1136 6.54295 13.8369 7.56091 12.7463 7.38326C11.6557 7.20561 10.7681 5.8351 11.0532 4.08481C11.3383 2.33452 12.615 1.31656 13.7056 1.49421C14.7962 1.67186 15.6838 3.04237 15.3987 4.79266Z",
    fill: "#C8874D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3764 4.87116C14.2231 5.81217 13.5401 6.34563 12.9704 6.25283C12.4007 6.16003 11.9224 5.4374 12.0757 4.49639C12.2289 3.55538 12.9119 3.02192 13.4816 3.11472C14.0513 3.20752 14.5296 3.93015 14.3764 4.87116Z",
    fill: "#B26B3F",
    stroke: "#A86027",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8717 8.71386C18.3765 9.42463 17.7268 9.90356 17.0965 10.1177C16.466 10.3318 15.8914 10.2735 15.4714 9.98089C15.0514 9.68828 14.7977 9.16946 14.7801 8.50382C14.7626 7.83843 14.9868 7.06304 15.482 6.35227C15.9772 5.6415 16.6269 5.16257 17.2572 4.94848C17.8876 4.73431 18.4623 4.79263 18.8822 5.08524C19.3022 5.37785 19.556 5.89667 19.5735 6.56231C19.591 7.2277 19.3669 8.00309 18.8717 8.71386Z",
    fill: "#C8874D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8873 8.50225C17.6076 8.90379 17.2409 9.17378 16.8862 9.29428C16.5313 9.41483 16.2102 9.38131 15.9765 9.21854C15.7429 9.05576 15.6002 8.76615 15.5903 8.39147C15.5805 8.01695 15.7067 7.57947 15.9865 7.17793C16.2662 6.77639 16.6329 6.5064 16.9876 6.3859C17.3425 6.26535 17.6636 6.29887 17.8973 6.46164C18.1309 6.62442 18.2736 6.91403 18.2835 7.28871C18.2933 7.66323 18.1671 8.10071 17.8873 8.50225Z",
    fill: "#B26B3F",
    stroke: "#A86027",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1131 12.0747C16.1131 12.7498 16.0498 13.711 15.836 14.5653C15.7292 14.9922 15.5895 15.3731 15.4144 15.6733C15.2389 15.974 15.0449 16.165 14.8403 16.2621C13.9038 16.7063 13.2567 16.639 12.6103 16.4394C12.3861 16.3701 12.1806 16.2916 11.9556 16.2056C11.8189 16.1534 11.675 16.0984 11.5152 16.041C11.1147 15.8972 10.6679 15.7608 10.1537 15.7007C9.60646 15.6367 9.09892 15.7207 8.63245 15.8475C8.33947 15.9272 8.03105 16.0342 7.74175 16.1346C7.59232 16.1864 7.44799 16.2365 7.31352 16.2801C6.48409 16.5491 5.72709 16.6878 4.82953 16.2621C4.63694 16.1707 4.46685 15.9927 4.32304 15.703C4.17812 15.411 4.07579 15.036 4.00761 14.608C3.88344 13.8285 3.88522 12.9675 3.88663 12.2811C3.88678 12.2104 3.88692 12.1415 3.88692 12.0747C3.88692 8.63885 6.34539 5.88184 10.0957 5.88184C11.9856 5.88184 13.4795 6.57886 14.5036 7.68228C15.532 8.79035 16.1131 10.3374 16.1131 12.0747Z",
    fill: "#C8874D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1009 11.7948C14.1009 12.2455 14.0586 12.8881 13.9155 13.4602C13.844 13.7461 13.7501 14.0028 13.6314 14.2061C13.5125 14.4097 13.3791 14.5427 13.2351 14.611C12.6031 14.9108 12.1638 14.8655 11.7274 14.7307C11.5774 14.6843 11.4389 14.6314 11.2883 14.5739C11.1974 14.5392 11.1021 14.5028 10.9972 14.4651C10.7318 14.3698 10.4371 14.2799 10.0985 14.2403C9.73996 14.1984 9.4067 14.2533 9.09847 14.3371C8.90448 14.3899 8.70143 14.4603 8.50963 14.5269C8.40985 14.5615 8.31311 14.5951 8.22227 14.6245C7.66749 14.8045 7.15371 14.8997 6.54509 14.611C6.40826 14.5461 6.29055 14.421 6.19273 14.2239C6.09426 14.0255 6.02546 13.7724 5.97982 13.4858C5.89674 12.9643 5.89794 12.3886 5.8989 11.9322C5.899 11.8851 5.89909 11.8392 5.89909 11.7948C5.89909 9.49124 7.5488 7.64082 10.0636 7.64082C11.3299 7.64082 12.3329 8.10809 13.021 8.84945C13.7117 9.5936 14.1009 10.6314 14.1009 11.7948Z",
    fill: "#B26B3F",
    stroke: "#A86027",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.918,
    cy: 18.953,
    r: 7.15654,
    transform: "rotate(8.06239 25.918 18.953)",
    fill: "#B26B3F",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.1019,
    cy: 17.8716,
    rx: 6.65716,
    ry: 5.62581,
    transform: "rotate(8.06239 26.1019 17.8716)",
    fill: "#C8874D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.918,
    cy: 18.953,
    r: 7.15654,
    transform: "rotate(8.06239 25.918 18.953)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9482,
    cy: 18.5323,
    rx: 0.511738,
    ry: 0.526937,
    transform: "rotate(8.06239 22.9482 18.5323)",
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2746,
    cy: 20.1507,
    rx: 0.583454,
    ry: 0.600782,
    transform: "rotate(8.06239 22.2746 20.1507)",
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.9724,
    cy: 18.569,
    r: 2.99954,
    transform: "rotate(8.06239 25.9724 18.569)",
    fill: "#7B441B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.9419,
    cy: 16.101,
    rx: 1.0567,
    ry: 1.08808,
    transform: "rotate(8.06239 29.9419 16.101)",
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4912,
    cy: 16.3651,
    rx: 0.820583,
    ry: 0.844955,
    transform: "rotate(8.06239 21.4912 16.3651)",
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5577,
    cy: 14.0598,
    rx: 0.511738,
    ry: 0.526937,
    transform: "rotate(8.06239 25.5577 14.0598)",
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0533,
    cy: 18.9636,
    rx: 0.511738,
    ry: 0.526937,
    transform: "rotate(8.06239 30.0533 18.9636)",
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6958,
    cy: 26.5808,
    r: 5.25339,
    fill: "#B26B3F",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7186,
    cy: 25.7569,
    rx: 5.00243,
    ry: 4.22743,
    fill: "#C8874D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6958,
    cy: 26.5808,
    r: 5.25339,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4419,
    cy: 26.5808,
    rx: 0.384538,
    ry: 0.395959,
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.1113,
    cy: 27.8559,
    rx: 0.438428,
    ry: 0.451449,
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6957,
    cy: 26.2893,
    r: 2.25396,
    fill: "#7B441B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.389,
    cy: 24.0347,
    rx: 0.794038,
    ry: 0.817621,
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.12943,
    cy: 25.1219,
    rx: 0.616616,
    ry: 0.634929,
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9119,
    cy: 22.9782,
    rx: 0.384538,
    ry: 0.395959,
    fill: "#B26B3F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7736,
    cy: 26.1528,
    rx: 0.384538,
    ry: 0.395959,
    fill: "#B26B3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_3361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.3625,
    height: 33,
    fill: "white",
    transform: "translate(0.210205)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainPetCookie);
export default __webpack_public_path__ + "static/media/icon-main-pet-cookie.cf04a9bfd2d2815f477f1cace47472e0.svg";
export { ForwardRef as ReactComponent };